module.exports = __webpack_public_path__ + "img/quietComfort-45_2.1aacdfa7.jpg";